import { PayloadAction, createSlice } from '../../shims/redux-toolkit';

import { CollabManager } from './collab-manager';

export interface CollabState {
  byContentId: Record<string, CollabManager>;
}

const initialState: CollabState = {
  byContentId: {},
};

const contentSlice = createSlice({
  name: 'collab',
  initialState,
  reducers: {
    addDatabase: (
      state,
      action: PayloadAction<{
        contentId: string;
        collabManager: CollabManager;
      }>
    ) => {
      (state.byContentId[action.payload.contentId] as unknown as CollabManager) =
        action.payload.collabManager;
    },
  },
});

export default contentSlice;
